<template lang="html">
  <div class="blog-group-container">
    <div class="group-title">{{ title }}</div>
    <div class="group-items">
      <BlogGroupProduct
        v-for="product in products"
        :product="product"
        :key="product.id"
      />
    </div>
  </div>
</template>

<script>
import BlogGroupProduct from "@/components/blogEntry/BlogGroupProduct.vue";

export default {
  components: {
    BlogGroupProduct
  },

  props: {
    products: {
      type: Array,
      required: false
    },

    title: {
      type: String,
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.blog-group-container /deep/ {
  .group-title {
    padding: 5px;
    padding-left: 15px;
    background-color: #f6f6f6;
    text-transform: capitalize;
    letter-spacing: 1px;
  }

  .group-items {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blogEntry/BlogGroup.vue